/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ role: NonNullable<unknown> }} Coinvestments_Draftemail_Access_Alreadyhasaccess4Inputs */

const en_coinvestments_draftemail_access_alreadyhasaccess4 = /** @type {(inputs: Coinvestments_Draftemail_Access_Alreadyhasaccess4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`already has access · ${i?.role}`)
};

/**
* | output |
* | --- |
* | "already has access · {role}" |
*
* @param {Coinvestments_Draftemail_Access_Alreadyhasaccess4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_access_alreadyhasaccess4 = /** @type {((inputs: Coinvestments_Draftemail_Access_Alreadyhasaccess4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Access_Alreadyhasaccess4Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_access_alreadyhasaccess4(inputs)
});
export { coinvestments_draftemail_access_alreadyhasaccess4 as "coInvestments_draftEmail_access_alreadyHasAccess" }